export class TableEventTimeBucket {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "startTs",
            "baseName": "startTs",
            "type": "number",
            "format": "double"
        },
        {
            "name": "records",
            "baseName": "records",
            "type": "number",
            "format": "double"
        }
    ];
    static getAttributeTypeMap() {
        return TableEventTimeBucket.attributeTypeMap;
    }
    constructor() {
    }
}
